// extracted by mini-css-extract-plugin
export default {"white-background":"ParticipantsPage_white-background__viyo2","main":"ParticipantsPage_main__Xx9IV","main_title":"ParticipantsPage_main_title__oExHO"};